import type ExtensibilityState from './schema/ExtensibilityState';
import type TaskPaneRunningInstance from './schema/TaskPaneRunningInstance';
import { createStore } from 'satcheljs';
import type { ExtensibilityHostItem } from './schema/ExtensibilityHostItem';
import { initializeCompliance } from './schema/Compliance';
import { InitializeContextualCalloutState } from './schema/ContextualCalloutState';
import { ObservableMap } from 'mobx';
import type IExtendedAddinCommand from './schema/interfaces/IExtendedAddinCommand';
import type TaskPaneType from './schema/TaskPaneType';
import type { ActiveDialog } from './schema/interfaces/Dialog';
import type { AddinLocation } from 'owa-addins-types';

const store: ExtensibilityState = createStore<ExtensibilityState>('extensibility', {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (17,5): Type 'null' is not assignable to type 'IEnabledAddinCommands'.
    // @ts-expect-error
    EnabledAddinCommands: null,
    HostItems: new ObservableMap<string, ExtensibilityHostItem>(),
    IsPreinstalledTeachingUIAvailable: false,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (23,5): Type 'null' is not assignable to type 'ExtensibilityContext'.
    // @ts-expect-error
    Context: null,
    frameworkComponentHostItemIndexMap: new ObservableMap<
        string,
        AddinLocation /* addinLocation consisting of hostItemIndex and targetWindow*/
    >(),
    taskPanes: new ObservableMap<
        string /*key: tabId*/,
        ObservableMap<TaskPaneType, TaskPaneRunningInstance>
    >(),
    activeDialogs: new ObservableMap<string, ActiveDialog>(),
    ExtensibilityStateIsDirty: false,
    contextualCalloutState: InitializeContextualCalloutState(),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (38,5): Type 'null' is not assignable to type 'RunningInstance'.
    // @ts-expect-error
    runningContextualAddinCommand: null,
    runningUILessExtendedAddinCommands: new ObservableMap<
        string /*key: stringified AddinInstance value which consists of tabId and HostItemIndex*/,
        ObservableMap<string, IExtendedAddinCommand>
    >(),
    autoRunAddinCommandWaitingQueue: new ObservableMap<
        string /*key: stringified AddinInstance value which consists of tabId and HostItemIndex*/,
        Array<IExtendedAddinCommand>
    >(),
    compliance: initializeCompliance(),
    activeAutorunUilessFrames: new ObservableMap<string, any>(),
})();

export default store;
